import _toConsumableArray from "@babel/runtime/helpers/toConsumableArray";
import { chartColorTokens } from './colorTokens/chartColorTokens';
var getColorTokenValue = function getColorTokenValue(colors, colorTokenMap, colorTokenDocLink) {
  if (!colors || !Array.isArray(colors) || !colors.length) {
    return;
  }
  var _colors$reduce = colors.reduce(function (acc, color) {
      var _colorTokenMap$color;
      var value = (_colorTokenMap$color = colorTokenMap[color]) !== null && _colorTokenMap$color !== void 0 ? _colorTokenMap$color : '';
      return {
        colorValues: [].concat(_toConsumableArray(acc.colorValues), [value]),
        invalidTokens: value ? acc.invalidTokens : [].concat(_toConsumableArray(acc.invalidTokens), ["".concat(color)])
      };
    }, {
      colorValues: [],
      invalidTokens: []
    }),
    colorValues = _colors$reduce.colorValues,
    invalidTokens = _colors$reduce.invalidTokens;
  if (invalidTokens.length) {
    // eslint-disable-next-line no-console
    console.error("Unsupported color token used: ".concat(invalidTokens.join(', '), ". ").concat(colorTokenDocLink ? "For supported color tokens, see ".concat(colorTokenDocLink) : ''));
  }
  return colorValues;
};
export var getChartColorTokenValues = function getChartColorTokenValues(colors) {
  var chartTokenLink = 'https://atlassian.design/components/tokens/all-tokens#color-chart';
  return getColorTokenValue(colors, chartColorTokens, chartTokenLink);
};